export class ElementAttributeDto {
  elementId: string;
  attributeTypeId: number;
  attributeValue: string;

  constructor(init: ElementAttributeDto) {
    Object.assign(this, init);
  }
}
